import { createStructuredSelector } from "reselect";
import {
    MARKETINTEL_OPENNING_LIST,
    MARKETINTEL_OPENNING_LIST_SUCCESS,
    MARKETINTEL_OPENNING_LIST_ERROR,
    MARKETINTEL_OPENNING_PAGE_SET,
    MARKETINTEL_OPENNING_HEADER,
    MARKETINTEL_OPENNING_SEARCH_SET,
    MARKETINTEL_OPENNING_SEARCH_CHANGE,
    MARKETINTEL_OPENNING_VIEW_MODAL_SET,
    MARKETINTEL_OPENNING_VIEW_DATA_SET,
    MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BID,
    MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BID_SUCCESS,
    MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BID_ERROR,
    ORIGIN_BID_TAB_SET,
    MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BIDDER,
    MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BIDDER_SUCCESS,
    MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BIDDER_ERROR,
    OPENNING_TAB_SET,
    MARKETINTEL_OPENNING_TAB_AWARD,
    MARKETINTEL_OPENNING_TAB_AWARD_SUCCESS,
    MARKETINTEL_OPENNING_TAB_AWARD_ERROR
} from "../actions";

export const NAME = 'marketintelOpenning';

export const MarketintelOpenningList = (filters, stateFilter) => ({
    type: MARKETINTEL_OPENNING_LIST,
    payload: {filters: filters, filtersState: stateFilter }
});

export const MarketintelOpenningListSuccess = (data) => ({
    type: MARKETINTEL_OPENNING_LIST_SUCCESS,
    payload: data
});

export const MarketintelOpenningListError = (error) => ({
    type: MARKETINTEL_OPENNING_LIST_ERROR,
    payload: error
});

export const MarketintelOpenningPageSet = (data) => ({
    type: MARKETINTEL_OPENNING_PAGE_SET,
    payload: data
});

export const MarketintelOpenningHeader = (data) => ({
    type: MARKETINTEL_OPENNING_HEADER,
    payload: data
})

export const MarketintelOpenningSearchSet = (data) => ({
    type: MARKETINTEL_OPENNING_SEARCH_SET,
    payload: data
});

export const MarketintelOpenningSearchChangeSet = (data) => ({
    type: MARKETINTEL_OPENNING_SEARCH_CHANGE,
    payload: data
});

export const MarketintelOpenningViewModalSet = (data) => ({
    type: MARKETINTEL_OPENNING_VIEW_MODAL_SET,
    payload: data
});

export const MarketintelOpenningViewDataSet = (data) => ({
    type: MARKETINTEL_OPENNING_VIEW_DATA_SET,
    payload: data
});

export const MarketintelOpenningCountryOriginBid = (filters) => ({
    type: MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BID,
    payload: { filters: filters }
});

export const MarketintelOpenningCountryOriginBidSuccess = (data) => ({
    type: MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BID_SUCCESS,
    payload: data
});

export const MarketintelOpenningCountryOriginBidError = (error) => ({
    type: MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BID_ERROR,
    payload: error
});

export const MarketintelOpenningCountryOriginBidder = (filters) => ({
    type: MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BIDDER,
    payload: { filters: filters }
});

export const MarketintelOpenningCountryOriginBidderSuccess = (data) => ({
    type: MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BIDDER_SUCCESS,
    payload: data
});

export const MarketintelOpenningCountryOriginBidderError = (error) => ({
    type: MARKETINTEL_OPENNING_COUNTRY_ORIGIN_BIDDER_ERROR,
    payload: error
});

export const OriginBidTabSet = (data) => ({
    type: ORIGIN_BID_TAB_SET,
    payload: data
});


export const OpenningTabSet = (data) => ({
    type: OPENNING_TAB_SET,
    payload: data
});

export const MarketintelOpenningTabAward = (filters, stateFilter) => ({
    type: MARKETINTEL_OPENNING_TAB_AWARD,
    payload: { filters: filters, filtersState: stateFilter }
});

export const MarketintelOpenningTabAwardSuccess = (data) => ({
    type: MARKETINTEL_OPENNING_TAB_AWARD_SUCCESS,
    payload: data
});

export const MarketintelOpenningTabAwardError = (error) => ({
    type: MARKETINTEL_OPENNING_TAB_AWARD_ERROR,
    payload: error
});

const marketintelOpenning = (state) => state[NAME];

export const MarketintelOpenningSelector = createStructuredSelector({
    marketintelOpenning
})
